module.exports = "#canvas {\n    background: white;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/drawing-section/drawing-section.component.css
// module id = ./src/app/components/drawing-section/drawing-section.component.css
// module chunks = main